/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum MensagensAliases {
  AVATAR_0 = 'avatar-0',
  CHECKBOX_MENSAGEM_IMPORTANTE = 'checkbox-mensagem-importante',
  CHECKBOX_NOT_READ = 'checkbox-not-read',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  DATE_FIELD_0 = 'date-field-0',
  DATE_FIELD_1 = 'date-field-1',
  DECK_MENSAGENS = 'deck-mensagens',
  FETCH_MENSAGENS = 'fetch-mensagens',
  FIELD_DATA_LIBERACAO = 'field-data-liberacao',
  FIELD_FROM = 'field-from',
  FIELD_MENSAGEM_IMPORTANTE = 'field-mensagem-importante',
  FIELD_MENSAGEM_NAO_LIDA = 'field-mensagem-nao-lida',
  FIELD_UNTIL = 'field-until',
  FILTER_CONSULTA_MENSAGENS = 'filter-consulta-mensagens',
  FILTERED_LIST = 'filtered-list',
  HPMS_CUSTOM_CARD_MENSAGENS = 'hpms-custom-card-mensagens',
  HPMS_DYNAMIC_CONTENT_FIELD_STATUS = 'hpms-dynamic-content-field-status',
  MAPPER_0 = 'mapper-0',
  PANEL_0 = 'panel-0',
}
export { MensagensAliases };
